export type CartErrorKind =
  | 'expired'
  | 'access'
  | 'store'
  | 'product'
  | 'modifier'
  | 'price'
  | 'conflict'
  | 'offline'
  | 'unexpected';

export interface PublicCartError extends Error {
  publicCode?: string;
  response?: { status?: number };
}

export function cartErrorKind(error: unknown): CartErrorKind {
  const value = error as PublicCartError;
  if (typeof navigator !== 'undefined' && !navigator.onLine) return 'offline';
  switch (value.publicCode) {
    case 'FNB_PUBLIC_CART_EXPIRED':
      return 'expired';
    case 'FNB_PUBLIC_CART_ACCESS_DENIED':
    case 'FNB_PUBLIC_SESSION_INVALID':
    case 'FNB_PUBLIC_SESSION_EXPIRED':
      return 'access';
    case 'FNB_PUBLIC_CART_STORE_MISMATCH':
      return 'store';
    case 'FNB_PUBLIC_PRODUCT_UNAVAILABLE':
      return 'product';
    case 'FNB_PUBLIC_MODIFIER_INVALID':
    case 'FNB_PUBLIC_VARIANT_INVALID':
      return 'modifier';
    case 'FNB_PUBLIC_PRICE_CHANGED':
      return 'price';
    case 'FNB_PUBLIC_VERSION_CONFLICT':
      return 'conflict';
    default:
      return 'unexpected';
  }
}

export const cartErrorMessages: Record<CartErrorKind, string> = {
  expired: 'Giỏ hàng đã hết hạn. Hãy thêm món để bắt đầu giỏ mới.',
  access: 'Giỏ hàng không thuộc phiên hoặc cửa hàng hiện tại và đã được xóa an toàn.',
  store:
    'Bạn đang có giỏ hàng ở cửa hàng khác. Hãy hoàn tất hoặc xóa giỏ hiện tại trước khi đặt món tại cửa hàng này.',
  product: 'Món vừa tạm ngừng phục vụ. Vui lòng chọn món khác.',
  modifier: 'Lựa chọn thêm vừa thay đổi. Vui lòng cấu hình món lại.',
  price: 'Giá vừa thay đổi. Giỏ hàng đã được đồng bộ theo báo giá mới.',
  conflict: 'Giỏ hàng vừa được cập nhật ở nơi khác. Đã tải lại phiên bản mới nhất.',
  offline: 'Không có kết nối mạng. Thay đổi chưa được gửi và giỏ hiện tại được giữ nguyên.',
  unexpected: 'Chưa thể cập nhật giỏ hàng. Vui lòng thử lại.',
};
